import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 15 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.017 0a.98.98 0 0 1 .695.288l6.034 6.034a.983.983 0 0 1-1.39 1.39l-5.339-5.34-5.34 5.34a.983.983 0 0 1-1.389-1.39L6.322.288A.98.98 0 0 1 7.017 0" }, null, -1)
  ])))
}
export default { render: render }